import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  flex-direction: ${({ display }) => display};
  padding: 20px;
`;

export const Footer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: row;
`;
